module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/sunkissed-a97d00af889fdb96193df8f947fb86d2.svg";